import { useParams } from 'react-router';
import { TenantCodeProvider } from '@/lib/auth/TenantCodeContext';
import { normalizeTenantCode } from '@/lib/auth/authFlow';
import { AppLayout } from './AppLayout';

/**
 * Supplies the already-authenticated, already-validated URL tenant to route
 * components. AuthenticationController owns login, tenant switching and URL
 * correction before the router is rendered.
 */
export function TenantCodeLayout() {
  const { tenantCode } = useParams<{ tenantCode: string }>();
  const normalizedTenantCode = normalizeTenantCode(tenantCode);

  if (!normalizedTenantCode) return null;

  return (
    <TenantCodeProvider value={normalizedTenantCode}>
      <AppLayout />
    </TenantCodeProvider>
  );
}
